// Use $ instead of $ without replacing global $
(function ($) {
    $(document).ready(function () {
        if ($('.intro-with-icon').length > 0) {
            initActiveScrollSelector();
          };
       
    });


    function initActiveScrollSelector() {
      $(window).on("load scroll", function () { 
        var nav = $(".header"),
        nav_height = nav.outerHeight();
        var tab = $(".intro-with-icon");
        var scroll = $(window).scrollTop();
          var top = $('.intro-with-icon').offset().top - nav_height - 300;
          if (scroll >= top) {
            tab.find('.icon').addClass("animated");
          }         
      });
    }
  })(jQuery); 

